import React from "react";
import * as Icons from "lucide-react";
import { STATUS } from "@/data/seed";
import { cn } from "@/lib/utils";

// Status uses BOTH a label and an icon (never color alone).
export function StatusBadge({ status, size = "sm", className }) {
  const s = STATUS[status] || STATUS.available;
  const Icon = Icons[s.icon] || Icons.Circle;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border font-mono uppercase tracking-wide",
        size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-3 py-1 text-xs",
        className
      )}
      style={{ borderColor: `${s.color}55`, background: `${s.color}14`, color: s.color }}
      data-testid={`status-badge-${status}`}
      aria-label={`Status: ${s.label}`}
    >
      <Icon size={size === "sm" ? 11 : 13} aria-hidden />
      {s.label}
    </span>
  );
}

export function StatusDot({ status, className }) {
  const s = STATUS[status] || STATUS.available;
  const animated = ["working", "collaborating", "escalation"].includes(status);
  return (
    <span
      className={cn("inline-block h-2.5 w-2.5 rounded-full", animated && "status-pulse", className)}
      style={{ background: s.color, boxShadow: `0 0 8px ${s.color}` }}
      aria-hidden
    />
  );
}
